import React from 'react';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { Catcher } from '../';
import { getParenName } from '../../Pages/pagesBooks/childrenOfParents';
import { IComponentName } from '../../interfaces';
import { usePagesStoreDefaultComponent, usePagesStoreListName, usePreviousRoute, useRouterStore } from '../../hooks';
import { isAvailablePage } from '../../middleware';
import { tB } from '../../translate';
import Styles from '../styles/m_itemCardStyles.less';

interface IGoToPageButton {
    dataTest?: string;
    goToPage: IComponentName;
    isDisable?: boolean;
    runOnBack?: () => void;
}

export const GoToPageButton: React.FC<IGoToPageButton> = ({
    dataTest,
    goToPage,
    isDisable,
    runOnBack,
}: IGoToPageButton) => {
    const routerStore = useRouterStore();
    const prev = usePreviousRoute();
    const isAvailablePrev = !!prev && isAvailablePage(prev.name as IComponentName);
    const isRightBackToPage = isAvailablePage(goToPage);
    const parentToPage = getParenName(goToPage);
    const isRightBackToParentPage = !!parentToPage && isAvailablePage(parentToPage);
    const defaultListName = usePagesStoreListName();
    const isRightDefaultList = !!defaultListName && isAvailablePage(defaultListName);
    const defaultComponent = usePagesStoreDefaultComponent();

    const onClickGo = (): void => {
        runOnBack && runOnBack();
        if (isRightBackToPage) {
            routerStore.goTo(goToPage);
        } else if (isRightBackToParentPage) {
            routerStore.goTo(parentToPage);
        } else if (isRightDefaultList) {
            routerStore.goTo(defaultListName);
        } else if (isAvailablePrev) {
            routerStore.goBack();
        } else if (defaultComponent) {
            routerStore.goTo(defaultComponent.routeName);
        }
    };

    return (
        <Catcher>
            <Button
                className={Styles.mainButton}
                data-test={dataTest}
                disabled={isDisable}
                icon={<LeftOutlined />}
                onClick={onClickGo}
                type="primary"
            >
                {tB('Back')}
            </Button>
        </Catcher>
    );
};
